import { get } from 'helpers/api';

export const download = (file) => {
  get(file.path).then((file) => {
    window.open(file.downloadUrl, '_blank');
  });
};